import React, { Component } from 'react';

  // router 
   
  



class  Getdata extends Component {

 
   constructor(props){
     super(props)
     this.onDelete = this.onDelete.bind(this);
     this.onEdit = this.onEdit.bind(this);
      this.editSubmit = this.editSubmit.bind(this)
     this.state = {
       isEdit:false
     }
   }
  
   onDelete(e){
    e.preventDefault();
     const {onDelete , ID} = this.props
     onDelete(ID)
    //  console.log("judge")
   }
  
   onEdit(){
    //  console.log("-------")
     this.setState({isEdit:true})
   }
 
   editSubmit(event){
    event.preventDefault();
       //console.log("edit", this.title.value)
       const editmess ={
          field :this.field.value,
        //   objectID : this.objectID.value,
          value : this.value.value,
          id : this.props.ID
       }
       this.props.editNewMessage(editmess)
       this.setState({isEdit:false})
      
    //    this.objectID.value = ""
      //  console.log("edit", editmess)

   }
  render() {
    
   
     const {value, field , ID} = this.props;

       
          if ( this.state.isEdit == false) {
            return (

                    <tr key={ID}>
                            <td>   {field}</td>
                            <td> {value}</td>
                            <td style={{width:"25%"}}> 
                            <button class="button is-light is-rounded is-small " onClick={this.onDelete}><i class="far fa-trash-alt" style={{color:"red"}}></i></button>|
                            <button  class="button is-primary is-rounded is-small  " onClick={this.onEdit}><i class="far fa-edit"></i></button>
                        </td>
                    </tr>
            //    <div>  
            //       <div > 
                           
            //               <p>  {title} </p>
            //               <p>  {  objectID} </p>
                                        
            //                 <p> {author}  </p>
                          
            //              </div>
            //           <br/>
            //    </div>
            )
          }else{
            return (

              
              <div style={{width:"210%"}}> 
                 
                <form onSubmit={this.editSubmit}>
                <div class="columns">
                  <div class="column is-half">
                      <div class="control">
                      <textarea class="textarea is-grow" rows="5"  onChange={this.onChange}  ref={input =>this.field = input} defaultValue={field} required  placeholder="Feature Name"></textarea>

                    </div>
                  </div>
                  <div class="column">
                        <div class="control">
                        <textarea class="textarea is-grow" rows="5" ref={input =>this.value = input} defaultValue={value}required required  placeholder="Description"></textarea>
                        {/* <input class="input" type="text"  ref={input =>this.value = input} defaultValue={value} placeholder="Value"  /> */}
                      </div>

                  </div>
              
                </div>
                
                

                <input onChange={this.onChange}type="hidden"  defaultValue={ID} ref={input =>this.objectID   = input  } />
                <button class="button is-primary is-rounded  are-small" >save</button>
                 
            
                </form>
             </div>
          );
          }
          
        }

   
  


}

export default Getdata;


// WEBPACK FOOTER //
// ./src/component/company/inputdata.js